import React from 'react';
import { Typography, Box } from 'bonfire-kindling';
import { LocationPicker } from 'components';
import { useTranslation } from 'react-i18next';

const LocationSettings = props => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h1" component="h2" gutterBottom>
        {t('settings.location.title')}
      </Typography>
      <Box>
        <LocationPicker {...props} />
      </Box>
    </>
  );
};

export default LocationSettings;
